import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {SearchDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/search/searchDropdown';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {makeFilterRows} from '../../../../analytics/helpers/analyticsFiltersHelpers';
import {MacroModel} from '../../../../models/api/macroModel';
import {MacroDropdownItem} from './macroDropdownItem';

/*
 * Props.
 */

interface PickMacroDropdownProps extends PopoverTransferProps {
  macros: ReadonlyArray<MacroModel>;
  shouldRenderIcon?: boolean;
  onBackButtonClick?: () => void;
  onRunMacro: (macro: MacroModel) => void;
}

/*
 * Style.
 */

const TitleWrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

/*
 * Component.
 */

export const PickMacroDropdown: FC<PickMacroDropdownProps> = ({
  macros,
  shouldRenderIcon,
  onBackButtonClick,
  onRunMacro,
  ...popoverProps
}) => {
  const [query, setQuery] = useState('');
  const filteredData = filterRows(macros, query);

  const renderRow = (macro: MacroModel) => (
    <MacroDropdownItem key={macro.id} macro={macro} onRunMacro={onRunMacro} />
  );

  return (
    <SearchDropdown
      {...popoverProps}
      data={filteredData}
      query={query}
      onQueryChange={setQuery}
      renderRow={renderRow}
      width={300}
      headerTitle={
        <TitleWrapperDiv>
          {shouldRenderIcon && <Icon name="lightning" />}
          <Trans id="macros-dropdown-title">Macros</Trans>
        </TitleWrapperDiv>
      }
      headerBackButtonLabel={
        onBackButtonClick ? <Trans id="macros-dropdown-header-back">Back</Trans> : undefined
      }
      onHeaderBackButtonClick={onBackButtonClick}
      findRowHeight={50}
    />
  );
};

const filterRows = makeFilterRows<MacroModel>((item) => item.name);
